<template>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <p class="title text-xs-center">Update Advertiser URL</p>
        <v-form ref="form" v-model="valid" lazy-validation>
                    
          <v-autocomplete
            v-model="advertiser"
            :items="advertiserNames"
            :rules="[v => !!v || 'Please select advertiser name.']"
            label="Select Advertiser"
            persistent-hint
            required
          ></v-autocomplete>

          <v-autocomplete
            v-model="country"
            :items="countryNames"
            :rules="[v => !!v || 'Please select Country name.']"
            label="Select Country"
            persistent-hint
            required
            >
          </v-autocomplete>


          <v-autocomplete
            v-model="operator"
            :items="operatorNames"
            :rules="[v => !!v || 'Please select Operator name.']"
            :label="`Select Operator(First select country)`"
            persistent-hint
            required
          >
          </v-autocomplete>

          <v-text-field
            v-model="advertiserCampaignName"
            :rules="[v => !!v || 'Please provide advertiser campaign name.']"
            label="Advertiser Campaign Name"
            required
          ></v-text-field>

          <v-text-field
            type="number"
            v-model="cpa"
            label="CPA"
            required
          ></v-text-field>

          <v-text-field
            v-model="advertiserUrl"
            label="Advertiser Url"
            required
          ></v-text-field>
          
          <v-checkbox
            v-model="status"
            label="Advertiser Url Status"
            required
          ></v-checkbox>

          <div class="text-xs-center">
            <v-btn @click="cancel">cancel</v-btn>
            <v-btn
              color="primary"
              :disabled="!valid"
              @click="submit"
            >
              Update
            </v-btn>
          </div>
        </v-form>
      </v-flex>
    </v-layout>
</template>

<script>
  import axios from 'axios'

  import { SERVER_URL } from './../../constant.js'

  export default {
    data: () => ({
      valid: true,
      loading: false,

      savedAdvUrl: null,

      advertiser: '',
      advertisers: [],
      advertiserNames: [],
      searchAdvertiser: null,


      country: '',
      countries: [],
      countryNames: [],
      searchCountry: null,

      operator: '',
      operators: [],
      operatorNames: [],
      searchOperator: null,

      trafficType: '',
      trafficTypes: ['A', 'C', 'I', 'IG'],
      modelType: '',
      modelTypes: ['CPA', 'CPC', 'CPM', 'CPI'],
      status: false,
      advertiserCampaignName: '',
      cpa: '',
      advertiserUrl: ''

    }),
    props: {
      savedAdvertiserUrlId: String
    },
    created () {
      document.title = 'Edit Advertiser Url';
      var vm = this;
      Promise.all([
        axios.get(`${SERVER_URL}/advertiser/all`),
        axios.get(`${SERVER_URL}/country/all`),
        axios.get(`${SERVER_URL}/advertiser/url/byId/${vm.savedAdvertiserUrlId}`),
      ]).then(results => {
        results[0].data.forEach(val => {
          vm.advertisers.push(val)
          vm.advertiserNames.push(val.name)
        })
        results[1].data.forEach(val => {
          vm.countries.push(val)
          vm.countryNames.push(val.name)
        }),
        vm.savedAdvUrl = results[2].data;
        if (vm.savedAdvUrl) {
          vm.advertiser = vm.savedAdvUrl.advertiserName;
          vm.country = vm.savedAdvUrl.countryName;
          vm.operator = vm.savedAdvUrl.operatorName;
          vm.advertiserCampaignName = vm.savedAdvUrl.advertiserCampaignName;
          vm.advertiserUrl = vm.savedAdvUrl.advertiserUrl;
          vm.cpa = vm.savedAdvUrl.cpa;
          vm.status = vm.savedAdvUrl.status;
        }
      })
    },
   
    watch: {
      searchAdvertiser (val) {
        val && this.queryAdvertiserSelections(val)
      },
      searchCountry (val) {
        val && this.queryCountrySelections(val)
      },
      searchOperator (val) {
        val && this.queryOperatorSelections(val)
      },
      country (val) {
        var vm = this;
        vm.operators = [];
        vm.operatorNames = [];
        axios.get(`${SERVER_URL}/operator/bycountry/${val}`)
        .then(res => {
          res.data.forEach(val => {
            vm.operators.push(val);
            vm.operatorNames.push(val.name);
          })
        })
      }
    },
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          
          let selectedAdvertiser = this.advertisers.filter(adv => adv.name === this.advertiser)
          let selectedCountry = this.countries.filter(cntry => cntry.name === this.country)
          let selectedOperator = this.operators.filter(optor => optor.name === this.operator)

          var payload = {
            id: this.savedAdvUrl.id,
            advertiserUrlId: this.savedAdvUrl.advertiserUrlId,
            advertiserId: selectedAdvertiser[0].advertiserId,
            advertiserName: selectedAdvertiser[0].name,
            countryId: selectedCountry[0].countryId,
            countryName: selectedCountry[0].name,
            operatorId: selectedOperator[0].operatorId,
            operatorName: selectedOperator[0].name,
            trafficType: this.savedAdvUrl.trafficType,
            modelType: this.savedAdvUrl.modelType,
            advertiserCampaignName: this.advertiserCampaignName,
            advertiserUrl: this.advertiserUrl,
            cpa: this.cpa,
            status: this.status
          }
          axios.post(`${SERVER_URL}/advertiser/addUrl`, payload)
          .then(res => {
            this.$refs.form.reset()
            var showSnackbarEvent = new CustomEvent('showSnackbarEvent', {detail: 'Advertiser Url Updated Successfully'})
            document.dispatchEvent(showSnackbarEvent);
          })
        }
      },
      queryAdvertiserSelections (v) {
        this.loading = true
        this.advertiserNames = this.advertiserNames.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      },
      queryCountrySelections (v) {
        this.loading = true
        this.countryNames = this.countryNames.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      },
      queryOperatorSelections (v) {
        this.loading = true
        this.operatorFilter = this.operatorNames.filter(e => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      },
      clear () {
        this.$refs.form.reset()
      },
      cancel () {
        this.$router.go(-1);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/advertiser/EditAdvertiserUrl.vue